import React from 'react';
import { Button, Select } from 'antd';
import classNames from 'classnames';
import { equals, map, prop, toPairs } from 'ramda';
import { DOCUMENT_HISTORY_PERIOD_LABELS,
  DOCUMENT_HISTORY_SORT_LABELS,
  DOCUMENT_HISTORY_FILTER_DEFAULTS } from '../../../../_CONST';
import SearchBar from '../widget/SearchBar';

const TYPE_PILLS = [
  { label: 'Tous', value: null },
  { label: 'Widget', value: 'WIDGET' },
  { label: 'Section', value: 'SECTION' },
  { label: 'Document', value: 'DOCUMENT' }
];

const BASE_TYPE_PILL_CLASSES = 'px-3 py-1 rounded-full text-xs [&&]:!font-normal border';
const ACTIVE_TYPE_PILL_CLASSES = 'bg-flexi-primary-color text-white border-flexi-primary-color cursor-pointer';
const INACTIVE_TYPE_PILL_CLASSES = 'bg-white !text-flexi-text border-flexi-border hover:border-flexi-primary-color hover:!text-flexi-primary-color cursor-pointer';

const PERIOD_OPTIONS = map(([value, label]) => ({ value, label }), toPairs(DOCUMENT_HISTORY_PERIOD_LABELS));
const SORT_OPTIONS = map(([value, label]) => ({ value, label }), toPairs(DOCUMENT_HISTORY_SORT_LABELS));

// Notify the parent only once the user stops typing: `search` lives in the page-level
// filter state, so one update per keystroke would fire one history query per keystroke
// and re-render the whole entry list (highlighting + canvas truncation measurement).
const SEARCH_DEBOUNCE_MS = 300;

const SelectPill = ({ title, value, options, onChange, disabled }) => (
  <div className="flex items-center gap-2">
    <span className="text-xs font-bold uppercase text-flexi-grey">
      {title} :
    </span>
    <Select
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={options}
      size="small"
      className="w-44"
      popupClassName="text-xs"
    />
  </div>
);

const DocumentHistorySearchFilters = ({
  search,
  targetType,
  period,
  sort,
  onFilterChange,
  disabled
}) => (
  <div className="sticky top-0 z-10 bg-flexi-history-page-bg py-2">
    <SearchBar
      searchTerm={search}
      setSearchTerm={onFilterChange('search')}
      placeholder="Rechercher dans l'historique..."
      disabled={disabled}
      className="mb-4"
      iconPosition="prefix"
      debounceWait={SEARCH_DEBOUNCE_MS}
    />

    <div className="flex flex-row gap-6">
      <div className="flex items-center gap-2">
        <span className="text-xs font-bold uppercase text-flexi-grey">
          Type :
        </span>
        {map(({ value, label }) => {
          const isActive = equals(value, targetType);
          return (
            <Button
              key={label}
              type="button"
              onClick={() => onFilterChange('targetType')(isActive ? prop('targetType', DOCUMENT_HISTORY_FILTER_DEFAULTS) : value)}
              disabled={disabled}
              className={classNames(BASE_TYPE_PILL_CLASSES, {
                [ACTIVE_TYPE_PILL_CLASSES]: isActive,
                [INACTIVE_TYPE_PILL_CLASSES]: !isActive
              })}
              size="small"
            >
              {label}
            </Button>
          );
        })(TYPE_PILLS)}
      </div>

      <div className="flex items-center gap-6">
        <SelectPill
          title="Trier"
          value={sort}
          options={SORT_OPTIONS}
          onChange={onFilterChange('sort')}
          disabled={disabled}
        />
        <SelectPill
          title="Période"
          value={period}
          options={PERIOD_OPTIONS}
          onChange={onFilterChange('period')}
          disabled={disabled}
        />
      </div>
    </div>
  </div>
);

export default DocumentHistorySearchFilters;
